<template>
  <div class="border-t md:border-alpha-white-10">
    <slot />
  </div>
</template>

<script setup></script>
